import type { ComponentType, ReactNode, SVGProps } from 'react';
import { classNames } from 'primereact/utils';

type SettingsActionButtonProps = {
  children: ReactNode;
  Icon?: ComponentType<SVGProps<SVGSVGElement>>;
  className?: string;
} & ({ onClick: () => void; href?: never } | { href: string; onClick?: never });

/** Button for action rows (open a page, download, email). Renders an `<a>` when given `href`. */
export const SettingsActionButton = ({ children, Icon, className, onClick, href }: SettingsActionButtonProps) => {
  const classes = classNames(
    'border-theme-border-grey bg-theme-white text-theme-black hover:bg-theme-background-grey',
    'focus-visible:outline-fletchers-green-500 flex w-fit cursor-pointer items-center gap-2 rounded-[4px]',
    'border px-4 py-1.5 text-sm font-semibold',
    className,
  );

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={classes}>
        {Icon && <Icon className="shrink-0" width={16} height={16} aria-hidden />}
        {children}
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} className={classes}>
      {Icon && <Icon className="shrink-0" width={16} height={16} aria-hidden />}
      {children}
    </button>
  );
};
